const route = {
	path: 'rules-ats/:id/edit',
	name: 'rules-ats-edit',
	meta: {
		title: 'Editar Regla Ats',
	},
	component: () => import('@/pages/atsRules/ats-rules-new'),
	props: true,
};

export default route;



// WEBPACK FOOTER //
// ./src/router/rules-ats-edit.js